<template>
  <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
import store from '@/store/index.js';
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      // 直接滚动到顶部，不使用递归动画，避免锁定滚动条
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // 滚动动画完成后，确保滚动条被完全重置为0
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }, 1000);
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 56px;
  height: 56px;
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 99999999;
  cursor: pointer;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

#GoTop:hover {
  background: #10ccd2;
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(16, 204, 210, 0.3);
}

#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: #10ccd2;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
}

#GoTop:hover > span {
  color: #ffffff;
  transform: translateY(-2px);
}

/* 响应式设计 */
@media screen and (max-width: 767px) {
  #GoTop {
    width: 48px;
    height: 48px;
    right: 20px;
    bottom: 20px;
  }
  
  #GoTop > span {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue